import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { router } from './router';

function App() {
  const dataval = useSelector((state) => state.dataValue);

  return <RouterProvider router={router(dataval)} />;
}

export default App;
